var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx } from "@emotion/react/jsx-runtime";
import { RustLogomark, JavaLogomark, AlteryxLogomark, KafkaLogomark, DvcLogomark, KubernetesLogomark, GcpLogomark, AzureLogomark, SparkLogomark, PytorchLogomark, OpenAiLogomark, MlflowLogomark, DbtLogomark, DatabricksLogomark, AwsLogomark, AirflowLogomark, SnowflakeLogomark, BigQueryLogomark, RedshiftLogomark, DockerLogomark, ExcelLogomark, TheoryLogomark, TableauLogomark, SqlLogomark, SpreadsheetLogomark, ShellLogomark, ScalaLogomark, RLogomark, PythonLogomark, PowerBiLogomark, JuliaLogomark, GitLogomark } from "@datacamp/waffles/asset";
import { Avatar } from "@datacamp/waffles/avatar";
import { useMemo } from "react";
import SvgTechnologyFallbackIcon from "../assets/technology-fallback-icon.svg.js";
const TechLogo = (props) => {
  const _a = props, {
    technologyName
  } = _a, restProps = __objRest(_a, [
    "technologyName"
  ]);
  const [content, testId] = useMemo(() => {
    switch (technologyName) {
      case "Git":
        return [/* @__PURE__ */ jsx(GitLogomark, {}), technologyName];
      case "Julia":
        return [/* @__PURE__ */ jsx(JuliaLogomark, {}), technologyName];
      case "Power BI":
        return [/* @__PURE__ */ jsx(PowerBiLogomark, {}), technologyName];
      case "Python":
        return [/* @__PURE__ */ jsx(PythonLogomark, {}), technologyName];
      case "R":
        return [/* @__PURE__ */ jsx(RLogomark, {}), technologyName];
      case "Scala":
        return [/* @__PURE__ */ jsx(ScalaLogomark, {}), technologyName];
      case "Shell":
        return [/* @__PURE__ */ jsx(ShellLogomark, {}), technologyName];
      case "Google Sheets":
        return [/* @__PURE__ */ jsx(SpreadsheetLogomark, {}), technologyName];
      case "SQL":
        return [/* @__PURE__ */ jsx(SqlLogomark, {}), technologyName];
      case "Tableau":
        return [/* @__PURE__ */ jsx(TableauLogomark, {}), technologyName];
      case "Theory":
        return [/* @__PURE__ */ jsx(TheoryLogomark, {}), technologyName];
      case "Excel":
        return [/* @__PURE__ */ jsx(ExcelLogomark, {}), technologyName];
      case "Docker":
        return [/* @__PURE__ */ jsx(DockerLogomark, {}), technologyName];
      case "Redshift":
        return [/* @__PURE__ */ jsx(RedshiftLogomark, {}), technologyName];
      case "BigQuery":
        return [/* @__PURE__ */ jsx(BigQueryLogomark, {}), technologyName];
      case "Snowflake":
        return [/* @__PURE__ */ jsx(SnowflakeLogomark, {}), technologyName];
      case "Airflow":
        return [/* @__PURE__ */ jsx(AirflowLogomark, {}), technologyName];
      case "AWS":
        return [/* @__PURE__ */ jsx(AwsLogomark, {}), technologyName];
      case "Databricks":
        return [/* @__PURE__ */ jsx(DatabricksLogomark, {}), technologyName];
      case "dbt":
        return [/* @__PURE__ */ jsx(DbtLogomark, {}), technologyName];
      case "MLflow":
        return [/* @__PURE__ */ jsx(MlflowLogomark, {}), technologyName];
      case "OpenAI":
      case "ChatGPT":
        return [/* @__PURE__ */ jsx(OpenAiLogomark, {}), technologyName];
      case "PyTorch":
        return [/* @__PURE__ */ jsx(PytorchLogomark, {}), technologyName];
      case "Spark":
        return [/* @__PURE__ */ jsx(SparkLogomark, {}), technologyName];
      case "Azure":
        return [/* @__PURE__ */ jsx(AzureLogomark, {}), technologyName];
      case "GCP":
        return [/* @__PURE__ */ jsx(GcpLogomark, {}), technologyName];
      case "Kubernetes":
        return [/* @__PURE__ */ jsx(KubernetesLogomark, {}), technologyName];
      case "DVC":
        return [/* @__PURE__ */ jsx(DvcLogomark, {}), technologyName];
      case "Kafka":
        return [/* @__PURE__ */ jsx(KafkaLogomark, {}), technologyName];
      case "Alteryx":
        return [/* @__PURE__ */ jsx(AlteryxLogomark, {}), technologyName];
      case "Java":
        return [/* @__PURE__ */ jsx(JavaLogomark, {}), technologyName];
      case "Rust":
        return [/* @__PURE__ */ jsx(RustLogomark, {}), technologyName];
      default:
        return [/* @__PURE__ */ jsx(SvgTechnologyFallbackIcon, {}), `default-${technologyName}`];
    }
  }, [technologyName]);
  return /* @__PURE__ */ jsx(Avatar, __spreadValues({ content, "data-testid": testId }, restProps));
};
export {
  TechLogo
};
